export default __webpack_public_path__ + "static/media/cashout-cassette-2.34a98cfa.svg";